var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoardEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Dashboard-board-positions"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-board-positions",
    clipPath: "url(#clip-Dashboard-board-positions)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4303",
    "data-name": "Group 4303",
    transform: "translate(17 20) scale(1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4302",
    "data-name": "Group 4302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M8.933,11.925H12.68a1,1,0,0,0,1-1V6.864a1,1,0,0,0-1-1H8.933a1,1,0,0,0-1,1v4.061A1,1,0,0,0,8.933,11.925Zm1-4.061H11.68V9.925H9.933Z",
    fill: "#273762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M15.548,11.925H19.3a1,1,0,0,0,1-1V6.864a1,1,0,0,0-1-1H15.548a1,1,0,0,0-1,1v4.061A1,1,0,0,0,15.548,11.925Zm1-4.061H18.3V9.925H16.548Z",
    fill: "#273762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M22.208,11.925h3.747a1,1,0,0,0,1-1V6.864a1,1,0,0,0-1-1H22.208a1,1,0,0,0-1,1v4.061A1,1,0,0,0,22.208,11.925Zm1-4.061h1.747V9.925H23.208Z",
    fill: "#273762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M7.933,18.724a1,1,0,0,0,1,1H12.68a1,1,0,0,0,1-1V14.663a1,1,0,0,0-1-1H8.933a1,1,0,0,0-1,1Zm2-3.061H11.68v2.061H9.933Z",
    fill: "#273762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M14.548,18.724a1,1,0,0,0,1,1H19.3a1,1,0,0,0,1-1V14.663a1,1,0,0,0-1-1H15.548a1,1,0,0,0-1,1Zm2-3.061H18.3v2.061H16.548Z",
    fill: "#273762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M21.208,18.724a1,1,0,0,0,1,1h3.747a1,1,0,0,0,1-1V14.663a1,1,0,0,0-1-1H22.208a1,1,0,0,0-1,1Zm2-3.061h1.747v2.061H23.208Z",
    fill: "#273762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M7.933,27.179a1,1,0,0,0,1,1H12.68a1,1,0,0,0,1-1V23.118a1,1,0,0,0-1-1H8.933a1,1,0,0,0-1,1Zm2-3.061H11.68v2.061H9.933Z",
    fill: "#273762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M21.208,27.179a1,1,0,0,0,1,1h3.747a1,1,0,0,0,1-1V23.118a1,1,0,0,0-1-1H22.208a1,1,0,0,0-1,1Zm2-3.061h1.747v2.061H23.208Z",
    fill: "#273762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M33.5,31.5h-3V3.686a1,1,0,0,0-1-1H5.5a1,1,0,0,0-1,1V20.053a1,1,0,0,0,2,0V4.686h22V31.5H20.3V23.118a1,1,0,0,0-1-1H15.548a1,1,0,0,0-1,1V31.5H6.5V23.571a1,1,0,0,0-2,0V31.5h-3a1,1,0,0,0,0,2h32a1,1,0,0,0,0-2ZM16.548,24.118H18.3V31.5H16.548Z",
    fill: "#273762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M5.5,1.5h24a1,1,0,0,0,0-2H5.5a1,1,0,0,0,0,2Z",
    fill: "#273762"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardEmptyState);
export default __webpack_public_path__ + "static/media/board-empty-state.7c4aa44d2bb31e191944e12eda2a6a56.svg";
export { ForwardRef as ReactComponent };